"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetSkadRequestToJSON = exports.AdSetSkadRequestFromJSONTyped = exports.AdSetSkadRequestFromJSON = exports.instanceOfAdSetSkadRequest = void 0;
/**
 * Check if a given object implements the AdSetSkadRequest interface.
 */
function instanceOfAdSetSkadRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "appId" in value;
    isInstance = isInstance && "adSetId" in value;
    isInstance = isInstance && "skadEnabled" in value;
    return isInstance;
}
exports.instanceOfAdSetSkadRequest = instanceOfAdSetSkadRequest;
function AdSetSkadRequestFromJSON(json) {
    return AdSetSkadRequestFromJSONTyped(json, false);
}
exports.AdSetSkadRequestFromJSON = AdSetSkadRequestFromJSON;
function AdSetSkadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appId': json['app_id'],
        'adSetId': json['ad_set_id'],
        'skadEnabled': json['skad_enabled'],
    };
}
exports.AdSetSkadRequestFromJSONTyped = AdSetSkadRequestFromJSONTyped;
function AdSetSkadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'app_id': value.appId,
        'ad_set_id': value.adSetId,
        'skad_enabled': value.skadEnabled,
    };
}
exports.AdSetSkadRequestToJSON = AdSetSkadRequestToJSON;
